export default "__VITE_ASSET__Dk$6mdhO__"